var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { ErrorBoundary, Suspense } from "../../..";
export var Boundary = React.memo(function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(ErrorBoundary, __assign({}, props),
        React.createElement(Suspense, null, children)));
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQm91bmRhcnkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvZmVhdHVyZXMvY29yZS9jb21wb25lbnRzL0JvdW5kYXJ5LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsT0FBTyxLQUFLLEtBQUssTUFBTSxPQUFPLENBQUM7QUFFL0IsT0FBTyxFQUFFLGFBQWEsRUFBK0IsUUFBUSxFQUFFLE1BQU0sVUFBVSxDQUFDO0FBRWhGLE1BQU0sQ0FBQyxJQUFNLFFBQVEsR0FBRyxLQUFLLENBQUMsSUFBSSxDQUNoQyxVQUFDLEVBQXNCO0lBQXBCLElBQUEsUUFBUSxjQUFBLEVBQUssS0FBSyxjQUFwQixZQUFzQixDQUFGO0lBQ25CLE9BQU8sQ0FDTCxvQkFBQyxhQUFhLGVBQUssS0FBSztRQUN0QixvQkFBQyxRQUFRLFFBQUUsUUFBUSxDQUFZLENBQ2pCLENBQ2pCLENBQUM7QUFDSixDQUFDLENBQ0YsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCAqIGFzIFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuXG5pbXBvcnQgeyBFcnJvckJvdW5kYXJ5LCBFcnJvckJvdW5kYXJ5UHJvcHNJbnRlcmZhY2UsIFN1c3BlbnNlIH0gZnJvbSBcIi4uLy4uLy4uXCI7XG5cbmV4cG9ydCBjb25zdCBCb3VuZGFyeSA9IFJlYWN0Lm1lbW88RXJyb3JCb3VuZGFyeVByb3BzSW50ZXJmYWNlPihcbiAgKHsgY2hpbGRyZW4sIC4uLnByb3BzIH0pID0+IHtcbiAgICByZXR1cm4gKFxuICAgICAgPEVycm9yQm91bmRhcnkgey4uLnByb3BzfT5cbiAgICAgICAgPFN1c3BlbnNlPntjaGlsZHJlbn08L1N1c3BlbnNlPlxuICAgICAgPC9FcnJvckJvdW5kYXJ5PlxuICAgICk7XG4gIH1cbik7XG4iXX0=